import React, { useMemo } from 'react';
import { format, isToday, isSameMonth, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval } from 'date-fns';
import { Plus } from 'lucide-react';
import { CalendarShiftCard } from './CalendarShiftCard';

// Calendar-style Month view — 6 rows × 7 columns.
export function CalendarMonthView({ date, filteredShifts, onShiftClick, onCellClick }) {
  const monthStart = startOfMonth(date);
  const monthEnd = endOfMonth(date);
  const calStart = startOfWeek(monthStart, { weekStartsOn: 1 });
  const calEnd = endOfWeek(monthEnd, { weekStartsOn: 1 });
  const allDays = eachDayOfInterval({ start: calStart, end: calEnd });

  const shiftsByDate = useMemo(() => {
    const map = {};
    filteredShifts.forEach(s => {
      if (!map[s.date]) map[s.date] = [];
      map[s.date].push(s);
    });
    return map;
  }, [filteredShifts]);

  return (
    <div>
      <div className="grid grid-cols-7 border-b sticky top-0 z-20 bg-white">
        {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(d => (
          <div key={d} className="text-center py-2 text-xs font-medium text-muted-foreground border-r">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7">
        {allDays.map(day => {
          const dk = format(day, 'yyyy-MM-dd');
          const dayShifts = shiftsByDate[dk] || [];
          const inMonth = isSameMonth(day, date);
          return (
            <div key={dk} className={`min-h-[100px] border-r border-b p-1 group ${!inMonth ? 'bg-slate-50/50 opacity-50' : ''} ${isToday(day) ? 'bg-blue-50/40' : ''}`}>
              <div className="flex items-center justify-between mb-1">
                <p className={`text-xs font-medium ${isToday(day) ? 'text-blue-700 font-bold' : 'text-slate-600'}`}>{format(day, 'd')}</p>
                {inMonth && (
                  <button onClick={() => onCellClick(null, dk)} className="opacity-0 group-hover:opacity-100 transition-opacity w-5 h-5 flex items-center justify-center rounded hover:bg-slate-200">
                    <Plus className="w-3.5 h-3.5 text-slate-400" />
                  </button>
                )}
              </div>
              {dayShifts.slice(0, 3).map(s => <CalendarShiftCard key={s.id} shift={s} onClick={onShiftClick} compact />)}
              {dayShifts.length > 3 && <p className="text-[10px] text-muted-foreground text-center">+{dayShifts.length - 3} more</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
